import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 100px; /* Position above theme toggle */
  right: 30px;
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  background: var(--light-navy);
  border: 1px solid var(--border);
  color: var(--lightest-slate);
  cursor: pointer;
  z-index: 999; /* Below theme toggle */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

  opacity: ${props => (props.isVisible ? 1 : 0)};
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  transform: ${props =>
    props.isVisible ? 'translateY(0) scale(1)' : 'translateY(10px) scale(0.8)'};

  /* Touch-friendly hover effects */
  @media (hover: hover) {
    &:hover {
      background: var(--green);
      color: var(--navy);
      border-color: var(--green);
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 8px 25px rgba(100, 255, 218, 0.3);
    }
  }

  /* Touch device active state */
  &:active {
    transform: translateY(0) scale(0.95);
    background: var(--green);
    color: var(--navy);
    border-color: var(--green);
  }

  @media (max-width: 768px) {
    bottom: 90px; /* Position above mobile theme toggle */
    right: 20px;
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    font-size: 18px;
  }

  @media (max-width: 480px) {
    bottom: 84px;
    right: 16px;
    width: 46px;
    height: 46px;
    min-width: 46px;
    min-height: 46px;
    font-size: 16px;
  }

  .arrow {
    transition: transform 0.2s ease;
  }

  &:hover .arrow {
    transform: translateY(-2px);
  }
`;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <ScrollButton
      isVisible={isVisible}
      onClick={scrollToTop}
      aria-label="Scroll to top"
      title="Back to top">
      <span className="arrow">↑</span>
    </ScrollButton>
  );
};

export default ScrollToTop;
